enum ReferenceDataKey {
    ReferenceDataKeyId = 'ReferenceDataKeyId',
    Company = 'Company',
    Country = 'Country',
}

export default ReferenceDataKey;